import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import styles from "../../css/EditForm.module.css";

const EditJob = () => {
  const { jobId } = useParams();

  const [title, setTitle] = useState("");
  const [company, setCompany] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [requirements, setRequirements] = useState("");
  const [salary, setSalary] = useState("");
  const [jobType, setJobType] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchJobDetails();
  }, []);

  const fetchJobDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/recruiter/login");
        return;
      }

      const response = await axios.get(
        `https://techservicemarket-backend.onrender.com/api/recruiter/jobs/${jobId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const job = response.data;
      setTitle(job.title);
      setCompany(job.company);
      setLocation(job.location);
      setDescription(job.description);
      setRequirements(job.requirements.join(", "));
      setSalary(job.salary);
      setJobType(job.jobType);
    } catch (error) {
      console.error("Error fetching job details:", error);
      alert("Failed to fetch job details. Please try again.");
    }
  };

  const handleUpdateJob = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("You need to log in first.");
        navigate("/recruiter/login");
        return;
      }

      const updatedJob = {
        title,
        company,
        location,
        description,
        requirements: requirements.split(",").map((req) => req.trim()),
        salary,
        jobType,
      };

      await axios.put(
        `https://techservicemarket-backend.onrender.com/api/recruiter/jobs/${jobId}`,
        updatedJob,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Job updated successfully");
      navigate("/recruiter/dashboard");
    } catch (error) {
      console.error("Error updating job:", error);
      alert("Failed to update the job. Please try again.");
    }
  };

  return (
    <div className={styles.jobFormContainer}>
      <button
        className={styles.backButton}
        onClick={() => navigate("/recruiter/dashboard")}
      >
        ← Back to Dashboard
      </button>

      <h2>Edit Job</h2>
      <div className={styles.mainContent}>
        <input
          type="text"
          placeholder="Job Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="text"
          placeholder="Company Name"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="text"
          placeholder="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className={styles.inputField}
        />
        <textarea
          placeholder="Job Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className={styles.textareaField}
        />
        <input
          type="text"
          placeholder="Requirements (comma-separated)"
          value={requirements}
          onChange={(e) => setRequirements(e.target.value)}
          className={styles.inputField}
        />
        <input
          type="number"
          placeholder="Salary (optional)"
          value={salary}
          onChange={(e) => setSalary(e.target.value)}
          className={styles.inputField}
        />
        <select
          value={jobType}
          onChange={(e) => setJobType(e.target.value)}
          className={styles.selectInput}
        >
          <option value="">Select Job Type</option>
          <option value="Full-time">Full-time</option>
          <option value="Part-time">Part-time</option>
          <option value="Contract">Contract</option>
          <option value="Internship">Internship</option>
        </select>

        <button onClick={handleUpdateJob} className={styles.postButton}>
          Update Job
        </button>
      </div>
      <div className={styles.footer}>
        <footer>
          <p>&copy;2024 TechServiceMarket Software</p>
        </footer>
      </div>
    </div>
  );
};

export default EditJob;
